import { OpenInNewWindow } from "@/Helpers/helper";
import { cn } from "@/lib/utils";
import { useStaticData } from "@/Providers/Data";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const HelpUsAlert = () => {
  const dataState = useStaticData();
  const [isVisible, setIsVisible] = useState(false);
  const [staticContent, setStaticContent] = useState<{
    text: string;
    redirect: string;
    isExternalRedirect: boolean;
    bgColor?: string;
  }>(null);
  const navigate = useNavigate();

  const getStaticContent = async () => {
    try {
      const response = await dataState?.getDataFromType(
        "CreatorAlertRibbonContent"
      );
      setStaticContent(
        response[0] as {
          text: string;
          redirect: string;
          isExternalRedirect: boolean;
          bgColor?: string;
        }
      );
    } catch (error) {
      console.error("Error fetching static content:", error);
    }
  };

  // Fetch static content when the component mounts
  useEffect(() => {
    getStaticContent();
  }, []);
  useEffect(() => {
    const dismissed = sessionStorage.getItem("yearWrapAlertDismissed");
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem("yearWrapAlertDismissed", "true");
  };
  //   const icons = ["☁️", "🌟", "✨", "🎊", "❄️", "🎉"];
  return (
    <>
      {!window.location.pathname.includes("/influencer/helpUs") &&
        !window.location.pathname.includes(
          "/influencer/brandCollabs/details/"
        ) &&
        !window.location.pathname.includes("/influencer/build_profile") &&
        isVisible && (
          <div
            style={{ backgroundColor: staticContent?.bgColor || "#1a202c" }}
            className={cn(
              `relative w-full h-12  flex items-center justify-between px-4 overflow-hidden`
            )}
          >
            {/* Icons at the Start */}
            {/* <div className="absolute h-full left-5 flex flex-col gap-2 pl-4 z-0">
              {icons.map((icon, index) => (
                <span
                  key={index}
                  className="text-lg animate-caret-blink opacity-20 md:opacity-50 "
                  style={{
                    position: "absolute",
                    top: `${index * 5}px`, // Dynamic height (top to bottom)
                    left: `${index * 50}px`, // Dynamic height (top to bottom)
                    animationDuration: `${4 + index}s`,
                    animationDelay: `${index * 0.5}s`,
                  }}
                >
                  {icon}
                </span>
              ))}
            </div> */}

            {/* Main Text */}
            <span
              onClick={() => {
                if (staticContent?.isExternalRedirect) {
                  OpenInNewWindow({ link: staticContent?.redirect });
                } else {
                  staticContent?.redirect && navigate("/influencer/helpUs");
                }
              }}
              className="text-neutral-50 text-[10px] md:text-sm italic font-semibold leading-normal underline decoration-solid underline-offset-auto cursor-pointer text-center z-10 flex-1"
            >
              {staticContent?.text}
            </span>

            {/* Close Button */}
            <button
              onClick={handleClose}
              className="text-neutral-50 text-sm font-bold bg-transparent border-none cursor-pointer z-10 ml-4"
            >
              ✕
            </button>

            {/* Icons at the End */}
            {/* <div className="absolute h-full right-10 flex flex-col gap-2 pr-4 z-0">
              {icons.map((icon, index) => (
                <span
                  key={index}
                  className="text-lg animate-caret-blink opacity-20 md:opacity-50"
                  style={{
                    position: "absolute",
                    bottom: `${(4 - index) * 3}px`, // Dynamic height (bottom to top)
                    right: `${index * 50}px`, // Dynamic height (bottom to top)
                    animationDuration: `${4 + index}s`,
                    animationDelay: `${index * 0.5}s`,
                  }}
                >
                  {icon}
                </span>
              ))}
            </div> */}
          </div>
        )}
    </>
  );
};

export default HelpUsAlert;
